export const downloadBlob = (file: File, filename: string) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
